<template>
  <div
    class="cover-leval"
    :class="{
      'home-wrap': themeType === THEME_TYPE_PARTY,
      'home-wrap-normal': themeType === THEME_TYPE_COMMON,
      'home-wrap-none': themeType === THEME_TYPE_NONE,
    }"
    :style="styleObj.coverImg"
  >
    <template v-if="themeType === THEME_TYPE_NONE">
      <!-- 标题 -->
      <h1 v-html="showTitle" class="title"></h1>
      <!-- 描述 -->
      <div
        v-html="quesInfo?.content"
        class="tips"
        :class="{ 'ques-tips': quesInfo?.type === 1 }"
      ></div>
    </template>
    <template v-else-if="!styleObj.coverImg">
      <div  class="rule">
        <Button @click="showRule = true" class="btn">说明</Button>
      </div>
      <div>
        <h1 class="title">{{ $store.getters.getQuesInfo?.title }}</h1>
          <img
            v-if="isNormal"
            class="logo"
            src="@/assets/img/competition/home-logo-normal.png"
            alt=""
          />
          <img
            v-else
            class="logo"
            src="@/assets/img/competition/home-logo.png"
            alt=""
          />
        <p class="tips">
          共{{ $store.getters.getQuesInfo?.questionAmount }}题 每题{{
            $store.getters.getQuesSetting?.timeLimit
              ? $store.getters.getQuesSetting?.timeLimit
              : 30
          }}秒
        </p>
      </div>
    </template>
    <div @click.capture="clickCapture">
      <Button
        id="startBtnC"
        :disabled="limtLoading"
        @click="handleStartClick"
        class="start-btn"
        :class="{ 'mg-top-135': styleObj.coverImg }"
        >{{ $store.getters.getBtnText?.compBtnText }}</Button
      >
      <Button
        v-if="isShowPersonInfo"
        @click="handlePersonInfoClick"
        class="peroson-btn"
        >个人信息</Button
      >
    </div>
  </div>
  <!-- 规则弹窗 -->
  <Overlay :show="showRule" @click="showRule = false" :lock-scroll="false">
    <RuleDialog @close="showRule = false" />
  </Overlay>
  <!-- 密码框 -->
  <Password v-if="isPassword == 1" @onEmit="handlePasswordSubmit" />
  <BeforeToast
    v-if="showBeforeToast"
    @confirm="handleBeforeToastConfirm"
    @close="showBeforeToast = false"
  />
  <PersonQues
    v-if="showPersonList"
    @close="showPersonList = false"
    @finishedPerson="handleFinishedPerson"
    :personList="personList"
  />
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { Button, Overlay, Dialog } from 'vant'
import RuleDialog from './components/ruleDialog'
import BeforeToast from '@/components/beforeToast'
import { getQueryString, isInApp as isApp } from '@/utils/tools'
import axios from 'axios'
import { getPessonQuesList } from '@/api/index'
import { getUserSelectionInfo, getBindModuleInfo } from '@/api/person'
import { WebBridgeApi } from 'ijsbridge'
import { useCommonStyleEffect } from '@/effects/styleConfigEffect'
import { useCommonGetSubmitCount } from '@/effects/submitEffect'
import Password, { useShowPasswordEffect } from '@/components/password/Password'
import { DOWNLOAD_URL, DOWNLOAD_URL_LY, DOWNLOAD_URL_SD_NEWS_IOS, DOWNLOAD_URL_SD_NEWS_ANDROID } from '@/constants'
import { isAndroid } from 'vant/lib/utils'
import PersonQues from '../index/components/personQues'
import { THEME_TYPE_NONE, THEME_TYPE_COMMON, THEME_TYPE_PARTY } from '@/constants'

// 获取个人题型
const usePesonListEffect = () => {
  const personList = ref([])
  const store = useStore()


  // 有缓存给赋值
  const setHistroyData = () => {
    const historyData = JSON.parse(
      JSON.stringify(store.getters.getInputCacheListObj)
    )
    // 遍历缓存数据 如果有答题记录 则赋值
    personList.value.forEach((item) => {
      const history = historyData[item.questionKey]
      if (history) {
        item.value = history[history.length - 1]
      }
    })
  }

  const getData = async () => {
    const res = await getPessonQuesList({
      questionActiveKey: getQueryString('questionActiveKey'),
      type: 2,
    })

    personList.value = res?.data
    console.log('0--', personList.value)
    setHistroyData()
  }

  getData()
  return {
    personList,
  }
}

// 开始逻辑
const useStartClickEffect = (isLimit, showBeforeToast, isAgreeBeforeToast, personList, showPersonList) => {
  const router = useRouter()
  const route = useRoute()
  const store = useStore()
  const questionActiveKey = getQueryString('questionActiveKey')
  const isPreview = getQueryString('isPreview')
    ? getQueryString('isPreview')
    : 0
  const activeId = getQueryString('activeId')
  const unitId = getQueryString('unitId')

  // 处理点击开始
  const handleStartClick = () => {

    if (!isLimit.value && isPreview !== 1) {
      Dialog({ message: '已超过次数限制' })
      return
    }


    // 开启了填报前弹窗
    if (store.getters?.isShowBefore && !isAgreeBeforeToast.value) {
      showBeforeToast.value = true

      return
    }

    const param = {
      path: '/',
      query: {
        ...route.query
      },
      params: {}
    }
    const quesInfo = store.getters.getQuesInfo
    const userSelectionInfo = store.getters.getUserSelection
    // 绑定了个人信息 && 用户没有回答过 需要跳到个人信息页面去
    if (
      isPreview !== 1 &&
      !userSelectionInfo &&
      quesInfo.isLogin === 1  &&
      quesInfo.moduleId
    ) {
      param.query.oldPath = param.path
      param.path = '/person/info'
      param.query.first = 1

      router.push(param)

      return
    }

    // 有个人题型的答题之前需要弹一下框
    if (personList.value.length > 0) {
      showPersonList.value = true

      return
    }


    store.commit('setStartTime', {
      time: new Date(),
    })
    router.push(
      `/competition/question?questionActiveKey=${questionActiveKey}&isPreview=${isPreview}&activeId=${activeId}&unitId=${unitId}`
    )
  }

    // 答完个人题
  const handleFinishedPerson = () => {
    // 记录答题开始时间
    store.commit('setStartTime', {
      time: new Date(),
    })
    router.push(
      `/competition/question?questionActiveKey=${questionActiveKey}&isPreview=${isPreview}&activeId=${activeId}&unitId=${unitId}`
    )

  }


  // 点击个人信息
  const handlePersonInfoClick = () => {
    const param = {
      path: '/person/info',
      query: {
        ...route.query
      },
      params: {}
    }
    router.push(param)
  }

  return {
    handleStartClick,
    handlePersonInfoClick,
    handleFinishedPerson
  }
}

// 捕获点击事件 做一些限制，比如登录处理、暂停收集处理
const useClickEffect = (isLimit, getLimitInfo) => {
  const store = useStore()
  const quesInfo = store.getters.getQuesInfo
  const isInApp = isApp()
  const isPreview = getQueryString('isPreview')
    ? Number(getQueryString('isPreview'))
    : 0
  let flag = false
  // let message = '登录客户端后方可开始答卷哦，感谢您的配合~'
  // 开启登录弹窗
  if (quesInfo?.isLogin === 1 && !store.getters.getToken) {
    flag = true
    // app里未登录 直接调用登录接口
    if (isInApp) {
      flag = true
      WebBridgeApi.authorize().then(({ err, result }) => {
        if (err === 'cancel') {
          // message = '登录客户端后方可开始答卷哦，感谢您的配合~'
          flag = true
          WebBridgeApi.router({ route: 'back' })
        }
        const token = result.user.token
        store.commit('setToken', {
          token,
        })
        getLimitInfo(isLimit)
        useFetchPersonInfo()
        flag = false
        // localStorage.setItem('token', token)
      })
    }
  }
  const clickCapture = (e = {}, type) => {
    if (quesInfo === null) {
      Dialog({ message: '问卷未处于发布状态' })
      e.stopPropagation()
      return
    }
    // 预览不做处理
    if (isPreview === 1) {
      return
    }
    if ((quesInfo?.status === 3 || quesInfo?.status === 4) && !type) {
      Dialog({ message: '此系统已暂停收集，请等待再次开启后使用！' })
      e.stopPropagation()
      return
    }
    if (quesInfo?.status === 5 && !type) {
      Dialog({ message: '活动未开始' })
      e.stopPropagation()
      return
    }
    if (quesInfo?.status === 6 && !type) {
      Dialog({ message: '活动已结束' })
      e.stopPropagation()
      return
    }
    if (quesInfo?.isLogin === 1 && !isInApp) {
      if (!store.getters.getToken) {
        e.stopPropagation()
        handleWebLogin(store.getters.getQuesInfo)
      } else {
        return
      }
    }
    if (!flag) {
      return
    }
    if (isInApp) {
      WebBridgeApi.authorize().then(({ err, result }) => {
        if (err === 'cancel') {
          // message = '登录客户端后方可开始答卷哦，感谢您的配合~'
          flag = true
          WebBridgeApi.router({ route: 'back' })
        }
        const token = result.user.token
        store.commit('setToken', {
          token,
        })
        getLimitInfo(isLimit)
        useFetchPersonInfo()
        flag = false
      })
    }

    e.stopPropagation()
  }

  return {
    clickCapture,
  }
}

// web登录
const handleWebLogin = (quesInfo) => {

  const isFromIframe = getQueryString('isFromIframe')
  // 如果是iframe进来的，postMessage出去 教给外层登陆
  if (isFromIframe) {
    // postMessage出去token
    parent.postMessage(
      {
        needLogin: true
      },
      '*'
    )
    return
  }

  const orgid = getQueryString('orgid')
  const backurl = encodeURIComponent(window.location.href)
  let url = `https://app-auth.iqilu.com?orgId=${orgid}&_orgid_=${orgid}&backurl=${backurl}`
  if (quesInfo?.webLogin === 2) {
    if (orgid === '21') {
      if (isAndroid()) {
        url = DOWNLOAD_URL_SD_NEWS_ANDROID
      } else {
        url = DOWNLOAD_URL_SD_NEWS_IOS
      }
    } else if (orgid === '409') {
      url = DOWNLOAD_URL_LY
    } else {
      url =  `${DOWNLOAD_URL}?orgid=${orgid}`
    }

  }
  window.location.href = url
}

// 处理网页登录跳回来逻辑
const useWebLoginEffect = async (isLimit, getLimitInfo) => {
  const store = useStore()
  const token = window.location.search.substr(1).split('=')[1]
  if (token && !store.getters.getToken) {
    const { data } = await axios.get(
      `https://app-auth.iqilu.com/member/login_state?__token__=${token}`
    )
    if (data?.code === 1 && data?.data?.token) {
      store.commit('setToken', {
        token: data?.data?.token,
      })
      localStorage.setItem('token', data?.data?.token)
      let url = decodeURIComponent(window.location.href)
      if (url.indexOf('amp;') !== -1) {
        url = url.replace(/amp;/g, '')
      }
      window.location.replace(url)
      getLimitInfo(isLimit)
    }
  }

  if (store.getters.getToken) {
    useFetchPersonInfo(store)
  }
}

// 获取问卷绑定个人信息
const useFetchPersonInfo = async (store) => {
  const fetchData = async () => {
    const res = await getUserSelectionInfo({
      questionActiveKey: getQueryString('questionActiveKey'),
      token: store.getters.getToken,
    })

    if (res.ok) {
      store.commit('setUserSelection', {
        data: res.data,
      })
      // 查绑定的模板信息
      await useFetchModuleInfo(store)
    }
  }

  await fetchData()
}

// 获取模板信息
const useFetchModuleInfo = async (store) => {
  if (!store.getters.getQuesInfo.moduleId) {
    return
  }
  const fetchData = async () => {
    const res = await getBindModuleInfo({
      moduleId: store.getters.getQuesInfo.moduleId,
      orgId: store.getters.getOrgId,
    })
    if (res.ok) {
      store.commit('setModuleInfo', {
        data: res.data[0],
      })
    }
  }

  await fetchData()
}


export default {
  components: {
    Button,
    Overlay,
    RuleDialog,
    Password,
    BeforeToast,
    PersonQues
  },
  setup() {
    const store = useStore()

    const showRule = ref(false)

    // 获取答题次数
    const { isLimit, getLimitInfo, limtLoading } = useCommonGetSubmitCount()

    // 填报前弹窗
    const showBeforeToast = ref(false)
    const isAgreeBeforeToast = ref(false)

    const { personList } = usePesonListEffect()
    const showPersonList = ref(false)

    // 开始按钮
    const { handleStartClick, handlePersonInfoClick, handleFinishedPerson } = useStartClickEffect(isLimit, showBeforeToast, isAgreeBeforeToast, personList, showPersonList)

    const handleBeforeToastConfirm = () => {
      isAgreeBeforeToast.value = true
      showBeforeToast.value = false
      handleStartClick()
    }

    const { clickCapture } = useClickEffect(isLimit, getLimitInfo, showBeforeToast, isAgreeBeforeToast)

    useWebLoginEffect(isLimit, getLimitInfo)

    // 设置样式
    const { isNormal, styleObj } = useCommonStyleEffect()

    // 主题样式
    const themeType = computed(() => store.getters.getQuesSetting?.answerType)

    // 密码框相关
    const { isPassword, handlePasswordSubmit } =
      useShowPasswordEffect()

    // 是否显示个人信息按钮
    const isShowPersonInfo = computed(() => {
      console.log(store.getters.getToken, store.getters.getQuesInfo?.moduleId)
      return (
        store.getters.getToken &&
        store.getters.getQuesInfo?.moduleId
      )
    })

    const quesInfo = computed(() => store.getters.getQuesInfo)

    const showTitle = computed(() => {
      return store.getters.getQuesInfo?.title.replaceAll('\n', '<br/>')
    })

    return {
      showRule,
      limtLoading,
      personList,
      showPersonList,
      handleStartClick,
      handlePersonInfoClick,
      handleFinishedPerson,
      clickCapture,
      isNormal,
      themeType,
      showTitle,
      styleObj,
      isPassword,
      quesInfo,
      handlePasswordSubmit,
      showBeforeToast,
      handleBeforeToastConfirm,
      isShowPersonInfo,
      THEME_TYPE_PARTY,
      THEME_TYPE_COMMON,
      THEME_TYPE_NONE,
    }
  },
}
</script>

<style scoped lang="scss">
.home-wrap {
  width: 100%;
  height: 1624px;
  background: no-repeat top/100% url('../../assets/img/competition/home-bg.png');
}
.mg-top-135 {
  margin-top: 1025px !important;
}

// 无主题的时候
.home-wrap-none {
  height: 1624px;
  .title {
    margin: 0 40px;
    padding-top: 88px;
    margin-bottom: 88px;
    font-weight: bold;
    // line-height: 48px;
    line-height: 1.2;
    text-align: center;
    font-size: 60px;
    color: #333333;
    line-height: 1.2;
  }

  .tips {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 26px 60px;
    width: 700px;
    height: 385px;
    overflow-y: scroll;
    background: #f0f0f0;
    border-radius: 10px;
    margin-top: 88px;
    margin-bottom: 40px;
    height: 666px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 25px 0;
    }

    p {
      margin: 20px 0;
      line-height: 1.5;
      font-size: 32px;

      &:first-child {
        margin: 0;
      }
    }
  }


  .start-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 30px;
    width: 700px;
    height: 150px;
    border-radius: 10px;
    background: linear-gradient(-90deg, #1782f0 0%, #22a8f4 100%);
    box-shadow: none;
  }

  .peroson-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 40px;
    width: 700px;
    height: 150px;
    border-radius: 10px;
    background: linear-gradient(-90deg, #1782f0 0%, #22a8f4 100%);
    box-shadow: none;
  }
}

.home-wrap-normal {
  width: 100%;
  height: 1624px;
  background: no-repeat top/100%
    url('../../assets/img/competition/home-bg-normal.png');

  .start-btn, .peroson-btn {
    box-shadow: none;
    background: linear-gradient(265deg, #2b91ff, #1fbcff);
  }
  .title {
    font-size: 42px;
    color: #ffc527;
  }
  .tips {
    color: #4c8046;
  }
  .rule {
    .btn {
      color: #18b6fc;
      opacity: 0.9;
    }
  }
}
.tips {
  margin: 0;
  margin-top: 58px;
  text-align: center;
  color: #ffffff;
  font-size: 36px;
}
.rule {
  text-align: right;
  .btn {
    margin-top: 50px;
    margin-right: 40px;
    min-width: 118px;
    height: 48px;
    background: #f7fbfe;
    box-shadow: 0px 0px 10px 0px rgba(47, 117, 182, 0.1);
    opacity: 0.6;
    border-radius: 23px;
    font-size: 28px;
    color: #eb5046;
  }
}
.title {
  margin: 0;
  margin-top: 88px;
  text-align: center;
  color: #ffffff;
  font-size: 36px;
}
.logo {
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  width: 505px;
  height: 115px;
}
.start-btn {
  display: block;
  margin: 0 auto;
  margin-top: 730px;
  width: 433px;
  height: 111px;
  background: linear-gradient(0deg, #ff9c2e, #ffde3a);
  box-shadow: 0px 1px 10px 0px rgba(254, 167, 74, 0.57);
  border-radius: 56px;
  border: none;
  font-size: 42px;
  color: #ffffff;
}

.peroson-btn {
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  width: 433px;
  height: 111px;
  background: linear-gradient(0deg, #ff9c2e, #ffde3a);
  box-shadow: 0px 1px 10px 0px rgba(254, 167, 74, 0.57);
  border-radius: 56px;
  border: none;
  font-size: 42px;
  color: #ffffff;
}
</style>

<style lang="scss">
.home-wrap-none {
  .tips {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 26px 60px;
    width: 700px;
    height: 385px;
    overflow-y: scroll;
    background: #f0f0f0;
    border-radius: 10px;
    margin-top: 88px;
    margin-bottom: 40px;
    height: 666px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 25px 0;
    }

    p {
      margin: 20px 0;
      line-height: 1.5;
      font-size: 32px;

      &:first-child {
        margin: 0;
      }
    }
  }

}
</style>
